import type { CabinetMfaChallenge } from "@planerius/contracts/cabinet-auth"

/**
 * Начатая проверка вторым фактором.
 *
 * Хранится в памяти вкладки по той же причине, что и access-токен: mfaToken это половина
 * доступа, и класть его в localStorage значит отдать XSS готовый пропуск. Живёт он минуты,
 * так что переживать обновление страницы ему незачем — после F5 человек возвращается
 * на форму входа и вводит пароль заново.
 */
let challenge: CabinetMfaChallenge | null = null

export const mfaChallengeStore = {
  read(): CabinetMfaChallenge | null {
    if (challenge === null) return null
    if (Date.parse(challenge.expiresAt) <= Date.now()) {
      challenge = null
      return null
    }
    return challenge
  },

  write(next: CabinetMfaChallenge): void {
    challenge = next
  },

  clear(): void {
    challenge = null
  },
}
